import functions from './functions.js';
import calendar from  './calendar.js';
import Slider from "./Slider";
import {SimpleGuests} from "./simple-guests.js";

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '2,0,0', 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    init() {

        if(! $('.page-type-details')[0]) {
            return;
        }

        if($('#booking')[0]) {
            $(window).scroll(e => {
                const offset = $('#booking').offset().top - $('#booking').outerHeight();
    
                $(window).scrollTop() > 200 
                    ? $('.nav-top').addClass('visible') 
                    : $('.nav-top').removeClass('visible');
                
                $(window).scrollTop() > 550 && $(window).scrollTop() < offset 
                    ? $('.nav-bottom').addClass('visible') 
                    : $('.nav-bottom').removeClass('visible');
    
            });
        }

        let unitCardSlider = [];
        $('[id^=unit-card-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            unitCardSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                pager: false
            });
        });

        //modalUnit
        $('[id^=modalUnit]').on('shown.bs.modal', e => {
            let unitModalSlider = [];
            $('[id^=unit-modal-slider]').each((i, elem) => {
                const length = $(elem).find('.keen-slider__slide').length;
                unitModalSlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slidesPerView: 1,
                    spacing: 0,
                    pager: false
                });
            });
        });


        details.getParams();

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.objectId = $('#booking').attr('data-objectid');
        details.params.unitId = $('#booking').attr('data-unitid');

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if($('[data-calendarconfig]')[0]) {
            details.calendarInit();
        }

        if(details.params.dateFrom && details.params.dateTo) {
            if($('[name="dates"]')[0]._flatpickr) {
                $('[name="dates"]')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            } else if ($('.datepicker,.datepicker-range')[0]) {
                $('.datepicker,.datepicker-range')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            }
           details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        }

        details.getCalculation();

        if(details.params.guests && $('.simple-guests')[0]) {
            $('.simple-guests').each( (inex, elem) => {
                elem._simpleGuests.setValue(details.params.guests);
            })
        }

        $('[name="guests"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.guests = $target.val();
            functions.setUrlData(details.params, true);
        });


        $('[name="dates"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.splitCalendarDates($target.val());
            functions.setUrlData(details.params, true);
        });

        $('.btn-clear-dates').on('click', function (e) {
            $('.total-old').addClass('d-none');
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true);
            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
            details.getCalculation();
        });

        $('.btn-choose-dates').on('click', function (e) {
            functions.scrollToElement($("#booking"), 60);
            $('.datepicker,.datepicker-range')[0]._flatpickr.open();
        });



        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });
        
        details.loadReviews();
        details.showMore($('body'));


        $('.unit-modal').on('click', e => {
            const $target = $(e.currentTarget);
            $('[id=' + $target.attr('data-bs-tab') +']').tab('show');
        });

        $('[data-bs-target="#inquiryModal"]').on('click', function (e) {
            $('form#inquiry').find('[name="unitId"]').val($(this).attr('data-unitid'));
        })

        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            $.each($(e.currentTarget).serializeArray(), function (i, field) {
                params[field.name] = field.value;
            });

            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            params['recaptchaType'] = 'enterprise';

            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        $(".modal-body").html(response.data);

                        setTimeout(() => {
                            $('[data-bs-dismiss="modal"]').click();
                        }, 4000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });

    },
    showMore($elem) {
        $elem.find('.show-more').on('click', function (e) {
            e.preventDefault();
            const $target = $(this);
            const $block = $target.closest('.truncate-block');
            const $dots = $block.find('.dots');

            if ( ! $dots.hasClass('d-none')) {
                $block.find('.more-text').removeClass('d-none');
                $dots.addClass('d-none');
                $target.text($target.attr('data-less'));
            } else {
                $block.find('.more-text').addClass('d-none');
                $dots.removeClass('d-none');
                $target.text($target.attr('data-more'));
            }
        });
    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);

            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.attr('disabled', 'disabled');
                    }
                    $(".reviews").append(response.html);
                    details.showMore($(".reviews"));
                }
            });
        });
    },
    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        let defaultDate = $('[data-calendarconfig][data-defaultdate]').attr('data-defaultdate');
        let minDate = $('[data-calendarconfig]').attr('data-mindate');
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/

        calendar.calendar.init(
            $('.datepicker-range-book'),
            {
                availabilityMask : config.availabilityMask,
                minStay : config.minStay,
                periods : config.periods,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate ? minDate : 'today',
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar mx-auto'
            },
            details.callbackOnDatesSelected
        );
    },
    callbackOnDatesSelected(from, to) {
        
        $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : ! from ? 'selectDates' : 'selectDepartureDate'}));
        if ( to && ! to[1]) {
            $('.btn-booking').addClass('disabled');
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        //details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    getCalculation(unitId = null) {

        //console.log(details.params);

        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;
        
        if(
            (details.params.objectId || unitId)
            && details.params.guests 
            && dateFrom 
            && dateTo 
            && details.params.objectGroupId
        ) {

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
            )
            .done(response => {

                if(response.status) {
                    const data = response.data || [];

                    //console.log(data);

                    Object.entries(data).forEach(unit => {
                        const unitId = unit[0];
                        const unitData = unit[1];

                        const $btnBooking = $('.btn-booking[data-unitid=' + unitId + ']');

                        const $unit = $('.booking[data-unitid=' + unitId + ']')[0] ? $('.booking[data-unitid=' + unitId + ']') : $('.unit[data-unitid=' + unitId + ']');

                        $('.calendar-message').addClass('d-none').text('');

                        if(details.isBookable(unitData)) {

                            const unitCalc = unitData.calc;

                            const calcItems = unitCalc.items;
                            let priceOld = 0.00;
                            let priceOldEUR = 0.00;
                            let discountTitle = null;

                            calcItems.forEach(item => {
                                // popust za djecu ne ulazi u prikaz discount cijene
                                if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                    priceOld += item.itemTotal;
                                    priceOldEUR += item.itemTotalEUR;
                                }
                                if(item.itemType == 'discount') {
                                    discountTitle = item.itemTitle;
                                    if(item.data && item.data.text) {
                                        discountTitle = item.data.text;
                                    }
                                }
                            });

                            const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                            const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',');

                            $unit.find('.calc-message-block').addClass('d-none');
                            $unit.find('.unit-price-container').removeClass('d-none');

                            if($btnBooking.attr('href')) {
                                $btnBooking.attr('href',
                                    $btnBooking.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '&dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests
                                );
                            }

                            $btnBooking.removeClass('disabled');

                            $unit.find('.date-from').text(functions.formatDate(dateFrom, 'dd.mm.yyyy.'));
                            $unit.find('.date-to').text(functions.formatDate(dateTo, 'dd.mm.yyyy.'));
                            
                            $unit.find('.nights').text(unitCalc.nights);

                            $unit.find('.total').text(total);
                            $unit.find('.total-converted').text(totalEUR);

                            if(priceOld && priceOld != unitCalc.total) {
                                $unit.find('.total-old').removeClass('d-none').text(unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ','));
                            } else {
                                $unit.find('.total-old').addClass('d-none');
                            }
                            
                            $unit.find('.btn-select-dates').addClass('d-none');

                            $unit.find('.no-calculation').addClass('d-none');
                            $unit.find('.calculation').removeClass('d-none');

                            $unit.find('.from-label').addClass('d-none');
                            $unit.find('.total-label').removeClass('d-none');

                            let $btnBook = $unit.find('.btn-booking');
                            $btnBook.removeClass('d-none');
                            $btnBook.text(unitData.booking.status == 'Reservation' ? $btnBook.attr('data-book') : $btnBook.attr('data-request'));

                            $unit.find('.btn-choose-dates').addClass('d-none');
                            $unit.find('.btn-inquiry').addClass('d-none');

                        } else {
                            $unit.find('.btn-booking').addClass('disabled');
                            $unit.find('.unit-error-container').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                            $unit.find('.calc-message-block').removeClass('d-none');
                            $unit.find('.calc-message').html(details.getCalcErrorMessage(unitData.calc.message));
                            $unit.find('.unit-price-container').addClass('d-none');
                            
                            $unit.find('.no-calculation').removeClass('d-none');
                            $unit.find('.calculation').addClass('d-none');

                            $unit.find('.btn-select-dates').removeClass('d-none');

                            $unit.find('.total-label').addClass('d-none');
                            $unit.find('.total-old').addClass('d-none');
                            $unit.find('.from-label').removeClass('d-none');

                            $unit.find('.btn-booking').addClass('d-none');
                            $unit.find('.btn-choose-dates').addClass('d-none');
                            $unit.find('.btn-inquiry').removeClass('d-none');
                        }

                    });
                }

            }).fail(function (error) {
                console.log(error);
            });
        }

        else {
            $('.btn-booking').addClass('disabled');
            $('.no-calculation').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');

            $('.calc-message-block').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.btn-booking').addClass('d-none');
            $('.btn-choose-dates').removeClass('d-none');
            $('.btn-inquiry').addClass('d-none');

            $('.total-label').addClass('d-none');
            $('.total-old').toggleClass('d-none', ! $('.total-old').attr('data-minPriceHasDiscount'));
            $('.total-old').text($('.total-old').attr('data-minPriceHasDiscount') ? $('.total-old').attr('data-minPriceOld') : '');
            $('.from-label').removeClass('d-none');
            
        }
    }
}